// const CouponsPage = () => import('./list/CouponsPage.vue');

import CouponsPage from "./list/CouponsPage.vue";

const routes = [
  {
    path: '/coupons',
    name: 'coupons',
    component: CouponsPage,
    meta: {
      title: 'Coupons',
      requiresAuth: true
    }
  }
];

export default routes;
